export const KEY_CODES = {
  ENTER: 13,
  ESCAPE: 27,
  TAB: 9,
  ARROW_UP: 38,
  ARROW_DOWN: 40,
};
